import { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { Pagination, Spinner } from "@/components/ui"
import DetailTemplate from '@/components/DetailTemplate'

import { useBienContext } from "../BienContext"
import { fetchLocations, selectRegisteredLocations, setFilters } from "../../locations/locationsSlice"
import { FORM_TYPES } from '../../locations/LocationFormContext'
import Form from "../../locations/Form"
import LocationItem from "./LocationItem"
import LocationQuittances from "./LocationQuittances"

export default () => {
  const dispatch = useDispatch()
  const { bien } = useBienContext()

  const registeredLocations = useSelector(selectRegisteredLocations)
  const pagination = useSelector(state => state.locations.pagination)
  const filters = useSelector(state => state.locations.filters)
  const isLoading = useSelector(state => state.locations.loadingStatus.fetchList)

  const [showQuittances, setShowQuittances] = useState(false)

  useEffect(
    () => {
      dispatch(fetchLocations({bien_id: bien.id}))
    },
    [bien.id]
  )

  const [formType, setFormType] = useState(FORM_TYPES.NEW)

  const modalContent = () => showQuittances ?
  <LocationQuittances /> : 
  <Form formType={formType} />

  useEffect(() => {
    if(filters.page != pagination.currentPage) {
      const queryFilters = { ...filters, bien_id: bien.id}
      dispatch(fetchLocations(queryFilters))
    }
  }, [dispatch, filters])

  const handlePageChange = (page) => {
    dispatch(setFilters({ page }))
  }

  const onCloseModal = () => {
    setShowQuittances(false)
  }

  return (
    <DetailTemplate
      title="Historique des locataires"
      modalContent={modalContent()}
      bodyProps={{columns: 1}}
      onCloseModalCallback={onCloseModal}
      showBackdrop={showQuittances}
      showCloseButton={showQuittances}
    >
      <table className="table">
        <thead>
          <tr className="text-left">
            <th>Locataires</th>
            <th>Date d'effet du bail</th>
            <th>Date d'EDL entrée</th>
            <th>Date de fin de bail sortie</th>
            <th>Date d'EDL sortie</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          { isLoading && <tr><td colSpan="6" className="p-2 text-center"><Spinner/></td></tr>}
          { !isLoading && registeredLocations.length == 0 && <tr><td colSpan="6" className="p-2 text-center">Aucune location</td></tr>}
          { !isLoading && registeredLocations.length > 0 && 
            registeredLocations.map( (item, index) => <LocationItem item={item} key={index} changeFormType={setFormType} setShowQuittances={setShowQuittances} />)
          }
        </tbody>
      </table>
      {pagination.totalPages > 1 && (
        <Pagination 
          currentPage={pagination.currentPage}
          totalPages={pagination.totalPages}
          onPageChange={handlePageChange}
        />
      )}
    </DetailTemplate>
  )
}